import * as React from 'react';
import PropTypes from 'prop-types';
import {
  TimelineItemContainer,
  TimelineItemBullet,
  TimelineItemBulletWrapper,
  TimelineItemBulletIcon
} from './TimelineItem.style';
import { Caption, Meta } from '../../styled components/Typography';
import { dateFormatOptions } from '../../libs/dateFormatting';
import { timeFormatOptions } from '../../libs/timeFormatting';
import { printInShortDateAndHourFormat } from '../../libs/dateTimePrinting';

class TimelineItem extends React.Component {
  renderDateTime() {
    const { dateTimeObject, dateFormatSetting, timeFormatSetting, user } = this.props;
    return (
      <Caption $color="gray dark" data-test-timeline-item-timestamp>
        {printInShortDateAndHourFormat(
          dateTimeObject,
          timeFormatSetting,
          dateFormatSetting,
          false,
          true,
          ', '
        )}
        {user && `, ${user}`}
      </Caption>
    );
  }

  renderDescription() {
    const { description } = this.props;
    return <Meta data-test-log-item-description>{description}</Meta>;
  }

  renderBulletOrIcon() {
    const { iconBullet, iconBulletColor } = this.props;
    if (iconBullet) {
      return (
        <TimelineItemBulletWrapper
          $containsIcon
          data-test-timeline-item-icon-bullet-color={iconBulletColor}
          data-test-timeline-item-icon-bullet={iconBullet}
        >
          <TimelineItemBulletIcon $iconColor={iconBulletColor} icon={iconBullet} />
        </TimelineItemBulletWrapper>
      );
    }
    return (
      <TimelineItemBulletWrapper data-test-timeline-item-bullet $containsBullet>
        <TimelineItemBullet />
      </TimelineItemBulletWrapper>
    );
  }

  render() {
    const { showTimelineAxe } = this.props;
    return (
      <TimelineItemContainer
        $showTimelineAxe={showTimelineAxe}
        data-test-timeline-item
        data-test-timeline-item-show-timeline-axe={showTimelineAxe}
      >
        {this.renderBulletOrIcon()}
        <div tw="flex flex-col space-y-6">
          {this.renderDescription()}
          {this.renderDateTime()}
        </div>
      </TimelineItemContainer>
    );
  }
}

TimelineItem.defaultProps = {
  showTimelineAxe: false,
  iconBullet: false,
  iconBulletColor: false
};

TimelineItem.propTypes = {
  showTimelineAxe: PropTypes.bool,
  iconBullet: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  iconBulletColor: PropTypes.oneOfType([
    PropTypes.oneOf(['blue', 'red']),
    PropTypes.bool
  ]),
  description: PropTypes.string.isRequired,
  dateTimeObject: PropTypes.shape({}).isRequired,
  dateFormatSetting: PropTypes.oneOf(dateFormatOptions).isRequired,
  timeFormatSetting: PropTypes.oneOf(timeFormatOptions).isRequired,
  user: PropTypes.string.isRequired
};

export default TimelineItem;
